export const overlaps = (a: any[], b: any[]) => {
	return a.some((el) => b.includes(el));
};
